import { Badge, Dropdown, List, Menu } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

interface UnreadMessage {
    count: number
    user: {
        firstName: string
        id: string
        lastName: string
        telegramId: string
        userName: string
    }
}
interface HeaderChatNotificationProps {
    unreadMessages: { [chatId: string]: UnreadMessage };
}

export const HeaderChatNotification: React.FC<HeaderChatNotificationProps> = ({ unreadMessages }) => {
    const location = useLocation()
    const { t } = useTranslation()
    const unreadCount = Object.values(unreadMessages).reduce((sum, { count }) => sum + count, 0)

    const isChatPage = location.pathname === '/chat'

    const chatList = useMemo(() => (
        Object.entries(unreadMessages)
            ?.map(([chatId, { count, user }]) => ({
                chatId,
                count,
                user,
            }))
            .filter(item => item.count > 0)
    ), [unreadMessages]);

    const filteredChatList = useMemo(() => (
        chatList.filter(item => item.chatId !== location.pathname.split('/').pop())
    ), [chatList, location.pathname]);

    if (isChatPage || unreadCount === 0 || !(filteredChatList?.length > 0)) {
        return null
    }

    const menu = (
        <Menu>
            <List
                dataSource={filteredChatList}
                renderItem={(chat) => (
                    <List.Item key={chat.chatId}>
                        <Link to={`/chat/page/${chat.chatId}`}>{t('chatNumber') + chat?.user?.telegramId + `${chat?.user?.firstName ? ', ' + chat?.user?.firstName : ''}`}: {chat.count}</Link>
                    </List.Item>
                )}
            />
        </Menu>
    );

    return (
        <Dropdown overlay={menu} trigger={['click']}>
            <Badge count={unreadCount} offset={[10, 0]}>
                <BellOutlined style={{ fontSize: '24px', cursor: 'pointer' }} />
            </Badge>
        </Dropdown>
    );
};